/**
 * Split view (DECISIONS #53): where a ticket can show beside its list, and the addresses for
 * moving between that and the ticket's own page.
 */

/** Wide enough for a list beside a ticket. */
export const SPLIT_QUERY = "(min-width: 1280px)";

/** What the expand button passes to the ticket's own page: the list it came from. */
export interface FromList {
  from?: string;
}

/** A list address we made ourselves ("/tickets?status=new"), or null for anything else. */
export function listAddress(state: unknown): string | null {
  const from = (state as FromList | null)?.from;
  return typeof from === "string" && from.startsWith("/") && !from.startsWith("//") ? from : null;
}

/** The list with this ticket open beside it, or (reference null) with none open. */
export function withOpen(list: string, reference: string | null): string {
  const url = new URL(list, window.location.origin);
  if (reference) url.searchParams.set("open", reference);
  else url.searchParams.delete("open");
  return `${url.pathname}${url.search}`;
}
